import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Toggle from 'material-ui/Toggle';
import {HeadlineH1, HeadlineH2} from './text/Headlines';
import ActionButtonRow from '../components/ActionButtonRow';
import filterOutNotDefinedValues from '../helpers/filterOutNotDefinedValues';
import ErrorMessage from '../components/ErrorMessage';
import SuccessMessage from '../components/SuccessMessage';
import {
  ROLE_SELECT,
  ROLE_USER,
  ROLE_EMPLOYEE,
  ROLE_ADMIN,
  ROLE_SUPER_ADMIN,
} from '../constants/userConstants';
import Select from './Select';
import styled from 'styled-components';
import convertErrors from '../helpers/errorHelper';
import Selector from './Selector';
import {TwoColContent} from './container/TwoColContent';
import {Trans, withNamespaces} from 'react-i18next';
import {getLanguage} from '../helpers/getLanguage';

let REMOVE_CONFIRM_PHRASE = 'Ja, diese Daten unwiderruflich löschen.';

const ToggleWrapper = styled.div`
  white-space: nowrap;
  padding-top: 20px;
`;

const SubHeading = styled(HeadlineH2)`
  margin-top: 1em;
`;

class UserForm extends Component {
  constructor(props) {
    super(props);
    const {user} = props.data || {};
    this.state = {
      loginToken: '',
      loginName: '',
      active: true,
      name: '',
      role: ROLE_USER,
      reportsAllowed: false,
      clients: null,
      employees: this._getDefaultEmployees(props.user),
      showGenerateNewLoginTokenDialog: false,
      showRemoveDialog: false,
      removeConfirmPhrase: '',
      removeResult: undefined,
      ...filterOutNotDefinedValues(user),
    };
  }

  componentWillReceiveProps = newProps => {
    if (newProps.data.error) {
      const {graphQLErrors} = newProps.data.error || {};
      this.setState({errors: graphQLErrors});
    } else {
      const {user} = newProps.data || {};
      this.setState({errors: [], ...filterOutNotDefinedValues(user)});
    }
  };
  _goBack = () => this.props.history.goBack();

  _goBackToList = () => this.props.history.replace('/users');

  _renderHeadline = () => {
    const {t} = this.props;
    if (this._isNew()) {
      return <HeadlineH1>{t('userForm.newUser')}</HeadlineH1>;
    } else {
      return <HeadlineH1>{t('userForm.editUser')}</HeadlineH1>;
    }
  };

  _isNew = () => !this.props.match.params.id;

  _save = () => {
    const {t} = this.props;
    this.setState({savingStatus: t('userForm.willSaved')});
    const {clients, employees, ...state} = this.state;
    this.props
      .save({
        clients: clients ? clients.map(entry => entry._id) : [],
        employees: employees ? employees.map(entry => entry._id) : [],
        ...filterOutNotDefinedValues(state),
      })
      .then(
        ({
          data: {
            saveUser: {_id, employees},
          },
        }) => {
          this.setState({savingStatus: undefined});
          const contextUser = this.props.user;
          if (
            contextUser.role === ROLE_EMPLOYEE &&
            (!employees ||
              !employees.find(entry => entry._id === contextUser._id))
          ) {
            this._goBackToList();
          } else if (this._isNew()) {
            this.props.history.replace('/user/' + _id);
          } else {
            this.setState({messages: [t('userForm.savedSuccess')]});
          }
        }
      )
      .catch(rawErrors => {
        this.setState({savingStatus: undefined});
        let errors = convertErrors({...rawErrors, t: t});
        this.setState({errors});
        console.log('there was an error sending the query', errors);
      });
  };

  _renderButtons = () => {
    let {savingStatus} = this.state;
    let {
      user: {role},
      t,
    } = this.props;

    const editUserRole = this.state.role;
    let isSaving = !!savingStatus;
    return (
      <ActionButtonRow>
        <FlatButton onClick={this._goBack} label={t('userForm.back')} />
        <div>
          {!this._isNew() && (
            <FlatButton
              onClick={() =>
                this.setState({showGenerateNewLoginTokenDialog: true})
              }
              label={t('userForm.renewToken')}
            />
          )}
          {!this._isNew() && role === ROLE_ADMIN && (
            <FlatButton
              onClick={() => this.setState({showRemoveDialog: true})}
              label={t('userForm.delete')}
            />
          )}
          {!this._isNew() && editUserRole === ROLE_USER && (
            <FlatButton
              onClick={() =>
                this.props.history.replace(
                  `/art-collections/${this.props.match.params.id}`
                )
              }
              label={t('userForm.editCollection')}
            />
          )}
          <FlatButton
            primary
            onClick={this._save}
            label={isSaving ? savingStatus : t('userForm.save')}
            disabled={isSaving}
          />
        </div>
      </ActionButtonRow>
    );
  };

  _renderRemoveDialog() {
    let {
      state: {showRemoveDialog, removeConfirmPhrase, name, removeResult},
      props: {removeUser},
    } = this;
    const {t} = this.props;
    REMOVE_CONFIRM_PHRASE = t('userForm.removeConfirm');
    return (
      <Dialog
        title={t('userForm.deletePermanently')}
        modal
        open={showRemoveDialog}
        actions={[
          <FlatButton
            label={t('userForm.cancel')}
            onClick={() => this.setState({showRemoveDialog: false})}
          />,
          <FlatButton
            label={t('userForm.deletePermanently')}
            primary
            disabled={removeConfirmPhrase !== REMOVE_CONFIRM_PHRASE}
            onClick={() =>
              removeUser()
                .then(({data: {removeUser}}) => {
                  const {
                    userRemoved,
                    logsRemoved,
                    directoryRemoved,
                  } = removeUser;
                  if (userRemoved && logsRemoved && directoryRemoved) {
                    this._goBackToList();
                  } else {
                    this.setState({removeResult: removeUser});
                  }
                })
                .catch(this._showErrors)
            }
          />,
        ]}>
        <div>
          <Trans i18nKey={'userForm.deletePermanentlyText'}>
            Der Benutzer {{name}} und alle diesem zugehörige Daten werden
            entgültig gelöscht.
            <br />
            Dieser Vorgang kann nicht rückgängig gemacht werden.
            <br />
            <br />
            Sind Sie sich wirklich sicher?
            <br />
            Um diesen Vorgang zu bestätigen geben Sie bitte folgenden Text ein:
            <br />
            <br />
            {{REMOVE_CONFIRM_PHRASE}}
            <br />
          </Trans>
          <TextField
            id='removeConfirmPhrase'
            autoFocus={showRemoveDialog}
            autoComplete='off'
            type='text'
            fullWidth={true}
            onPaste={e => e.preventDefault()}
            value={removeConfirmPhrase}
            onChange={({target: {value}}) =>
              this.setState({removeConfirmPhrase: value})
            }
          />
          {removeResult && (
            <div>
              <Trans i18nKey={'userForm.error'}>
                <h3>Fehler</h3>
                Es konnten nicht alle Daten gelöscht werden.
                <br />
                Bitte wenden Sie sich mit folgenden Infos an die IT:
                <br />
              </Trans>
              <ul>
                {!removeResult.userRemoved && (
                  <li>{t('userForm.userCouldNotDeleted')}</li>
                )}
                {!removeResult.logsRemoved && (
                  <li>{t('userForm.logsCouldNotDeleted')}</li>
                )}
                {!removeResult.directoryRemoved && (
                  <li>{t('userForm.userDirectoryCouldNotDeleted')}</li>
                )}
              </ul>
            </div>
          )}
        </div>
      </Dialog>
    );
  }

  _renderGenerateNewLoginTokenDialog() {
    let {
      state: {showGenerateNewLoginTokenDialog},
      props: {generateNewLoginToken},
    } = this;
    const {t} = this.props;
    return (
      <Dialog
        title={t('userForm.renewToken')}
        modal
        open={showGenerateNewLoginTokenDialog}
        actions={[
          <FlatButton
            label={t('userForm.cancel')}
            onClick={() =>
              this.setState({showGenerateNewLoginTokenDialog: false})
            }
          />,
          <FlatButton
            label={t('userForm.confirmRenewToken')}
            primary
            onClick={() => {
              generateNewLoginToken().catch(this._showErrors);
              this.setState({showGenerateNewLoginTokenDialog: false});
            }}
          />,
        ]}>
        <div>
          {/* This translation is done by the trans component of i18n */}
          <Trans i18nKey={'userForm.loginTokenText'}>
            Der Login Token dieses Benutzers wird erneuert.
            <br />
            Zukünftiges Anmelden mit dem alten Login Token ist nicht mehr
            möglich.
            <br />
            Dieser Vorgang kann nicht rückgängig gemacht werden.
            <br />
            <br />
            Sind Sie sich wirklich sicher?
          </Trans>
        </div>
      </Dialog>
    );
  }

  _showErrors = rawErrors => {
    const {t} = this.props;
    let errors = convertErrors({...rawErrors, t: t});
    this.setState({errors});
    console.log('there was an error sending the mutation', rawErrors);
  };

  _filterSelf = ({_id}) => _id !== this.state._id;

  handleClientsChange = clients => {
    this.setState({clients});
  };
  _renderClientSelect = () => {
    const {clients} = this.state;
    const {allClients} = this.props.data;
    const {t} = this.props;
    if (!allClients || !allClients.length) return null;
    return (
      <div>
        <SubHeading>{t('userForm.assignedCollectors')}</SubHeading>
        <Selector
          items={allClients.filter(this._filterSelf)}
          selectedItems={clients || []}
          multiselect={true}
          renderItem={client => <div>{client.name}</div>}
          changeMethod={this.handleClientsChange}
        />
      </div>
    );
  };
  handleEmployeesChange = employees => {
    this.setState({employees});
  };
  _getDefaultEmployees = ({role, name, _id}) => {
    if (this._isNew() && role === ROLE_EMPLOYEE) return [{name, _id}];
    return [];
  };
  _renderEmployeeSelect = () => {
    const {employees} = this.state;
    const {allEmployees} = this.props.data;
    const {t} = this.props;
    if (!allEmployees || !allEmployees.length) return null;
    return (
      <div>
        <SubHeading>{t('userForm.responsibleEmployee')}</SubHeading>
        <Selector
          items={allEmployees.filter(this._filterSelf)}
          selectedItems={employees || []}
          multiselect={true}
          renderItem={employee => <div>{employee.name}</div>}
          changeMethod={this.handleEmployeesChange}
        />
      </div>
    );
  };

  render() {
    let {loginToken, loginName, active, name, role} = this.state;
    // const {allClients} = this.props.data;
    const {t} = this.props;

    if (
      this.state.role === ROLE_SUPER_ADMIN &&
      this.props.user.role !== ROLE_SUPER_ADMIN
    ) {
      return <div>this is not allowed</div>;
    }

    return (
      <div>
        <ErrorMessage
          errors={this.state.errors}
          clearErrors={() => this.setState({errors: []})}
        />
        <SuccessMessage
          messages={this.state.messages}
          clearMessages={() => this.setState({messages: []})}
        />
        <TwoColContent>
          {this._renderHeadline()}
          <ToggleWrapper>
            <Toggle
              label={
                t('userForm.user') +
                ' ' +
                (active ? t('userForm.activate') : t('userForm.blocked'))
              }
              toggled={active}
              onToggle={(_, active) => this.setState({active})}
            />
          </ToggleWrapper>
        </TwoColContent>
        {(this.props.user.role === ROLE_ADMIN ||
          this.props.user.role === ROLE_SUPER_ADMIN) && (
          <Select
            label={t('userForm.permission')}
            items={ROLE_SELECT(getLanguage(), this.props.user)}
            selectedItem={role}
            changeMethod={role => this.setState({role})}
          />
        )}
        <TextField
          autoFocus={this._isNew()}
          type='text'
          fullWidth={true}
          floatingLabelText='Name*'
          value={name}
          onChange={({target: {value}}) =>
            this.setState({
              name: value,
            })
          }
        />
        <TextField
          type='text'
          fullWidth={true}
          floatingLabelText='Login Name*'
          value={loginName}
          onChange={({target: {value}}) =>
            this.setState({
              loginName: value,
            })
          }
        />
        {loginToken && (
          <TextField
            type='text'
            fullWidth={true}
            floatingLabelText='Login Token'
            value={loginToken}
            onClick={({target}) =>
              target.setSelectionRange(0, target.value.length)
            }
          />
        )}

        {role === ROLE_EMPLOYEE && this._renderClientSelect()}
        {role === ROLE_USER && this._renderEmployeeSelect()}
        {this._renderButtons()}
        {this._renderGenerateNewLoginTokenDialog()}
        {this._renderRemoveDialog()}
      </div>
    );
  }
}

export default withNamespaces()(UserForm);



// WEBPACK FOOTER //
// ./src/components/UserForm.js